import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { Helmet } from 'react-helmet-async';
import { AgencyOverviewPage, parseAgencyOverviewSearch, type AgencyOverviewSearch } from '@/features/agency';
import { formatDocumentTitle } from '@/lib/document-title';

/**
 * Agency home: every salon's marketing results. Every agency member may view it (the parent layout gates non-agency
 * users; the API scopes salons). The period and the Assigned to filter live in the URL, so a filtered view can be shared.
 */
export const Route = createFileRoute('/_auth/agency/')({
  validateSearch: parseAgencyOverviewSearch,
  component: AgencyOverviewRoute,
});

function AgencyOverviewRoute() {
  const search = Route.useSearch();
  const navigate = useNavigate({ from: Route.fullPath });
  return (
    <>
      <Helmet defer={false}>
        <title>{formatDocumentTitle('Overview')}</title>
      </Helmet>
      <AgencyOverviewPage
        search={search}
        onSearchChange={(next: AgencyOverviewSearch) => void navigate({ search: next, replace: true })}
      />
    </>
  );
}
